<template>
  <div class="d-flex flex-column align-items-center justify-content-center p-5">
    <b-jumbotron bg-variant="white">
      <div class="h-100 d-flex flex-column flex-lg-row align-items-center">
        <div class="h-100 d-flex flex-column align-items-center justify-content-center">
          <b-img class="mr-5 mb-3" width="350" :src="require('../assets/seaway_logo.png')"></b-img>
          <p class="h2 font-weight-bold mb-5">Dealer Portal</p>
        </div>
        <div class="p-5">
          <login-card></login-card>
        </div>
      </div>
    </b-jumbotron>
  </div>
</template>
<script>
import LoginCard from "@/components/credentials/LoginCard";
import { AUTHENTICATED } from "../store/mutations/app";
export default {
  components: {
    LoginCard
  },
  mounted() {}
};
</script>
